var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "blog-a",
    d: "M19,2 C19.6418278,2 20,2.37309604 20,3 L20,18 L8,18 C7.48716416,18 7.06449284,18.3860402 7.00672773,18.8833789 L7,19 C7,19.5522847 7.44771525,20 8,20 L8,20 L20,20 L20,21 C20,21.626904 19.6418278,22 19,22 L7,22 C5.2536027,22 4,20.6941639 4,19 L4,5 C4,3.30583615 5.2536027,2 7,2 L19,2 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "blog-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blog-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#212529",
    transform: "rotate(-90 12 12)",
    xlinkHref: "#blog-a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 4,
    y: 8,
    fill: "#FFF",
    mask: "url(#blog-b)",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 10,
    y: 8,
    fill: "#FFF",
    mask: "url(#blog-b)",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 10,
    y: 11,
    fill: "#FFF",
    mask: "url(#blog-b)",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 4,
    y: 14,
    fill: "#FFF",
    mask: "url(#blog-b)",
    rx: 0.3
  }))));
};
export default SvgBlog;